import React from 'react';
import ProfitableGoingConcern from './ProfitableGoingConcern.router';
import ListingProvider from '../../providers/Listing';
import { LISTING_GOING_CONCERN } from 'models/Listing';
import { ListingProviderProps } from '../../providers/Listing/Listing.provider';

const ListingWrapper: React.FC<ListingProviderProps> = (props) => (
  <ListingProvider {...props} listingType={LISTING_GOING_CONCERN}>
    <ProfitableGoingConcern />
  </ListingProvider>
);

export default ListingWrapper;

export { default as profitableGoingConcernRoutes } from './routes';
